module.exports = __webpack_public_path__ + "img/gift.9f5677d8.png";